import { observer } from 'mobx-react-lite'

import { Button } from 'components/Button'
import { ReactComponent as CloseIcon } from 'components/DocRightRail/screens/ArticleTimer/MyTimer/icons/close.svg'

import { useRootStore } from 'stores/RootStore'
import { useMobileToolbar } from '../stores/MobileToolbarStore'

export const CollaborationDialogCloseButton = observer(function CollaborationDialogCloseButton({
  onClose,
}: { onClose?: () => void } = {}) {
  const rootStore = useRootStore()
  const mobileToolbarStore = useMobileToolbar()

  const handleClose =
    onClose ??
    (() => {
      mobileToolbarStore.closeTopTier()
      rootStore.docStore?.filters.deactivate('resolved')
      rootStore.comments.select(undefined)
    })

  return <Button preventFocusOnPress frontIcon={CloseIcon} variant="none" size="lg" onClick={handleClose} />
})
